import { typo } from '@design-system/styles'
import { css } from '@emotion/react'
import { zIndex } from '@mathflat/common/style'

const S = {
  common: {
    overlay: {
      background: 'rgba(0,0,0,.5)',
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      zIndex: zIndex.ModalPortal,
      overflow: 'auto',
    },
    content: {
      overflow: 'unset',
      position: 'relative',
      padding: 0,
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      borderRadius: 'var(--Radius-100)',
      boxShadow: `0 0 50px 0 rgba(0, 0, 0, 0.1)`,
      maxHeight: '100%',
      border: 'none',
    },
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: '0 !important',
  },

  video: {
    overlay: {
      background: 'rgba(0,0,0,.7)',
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      zIndex: zIndex.ModalPortal,
      overflow: 'auto',
    },
    content: {
      padding: 0,
      inset: 'auto',
      border: 'none',
      overflow: 'visible',
      background: 'transparent',
    },
  },

  insidebuttonStyle: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    zIndex: zIndex.ModalPortal,
  },
  outsideButtonStyle: {
    position: 'absolute',
    top: -38,
    right: -14,
    padding: 8,
    zIndex: zIndex.ModalPortal,
  },
  closeIcon: {
    width: '16px',
    height: '16px',
  },

  bottomCloseButton: css`
    position: absolute;
    right: 0;
    bottom: -10px;
    transform: translateY(100%);
    color: #fff;
  `,
  confirmModalOption: css`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    transform: translateY(100%);
    z-index: ${zIndex.ConfirmModalPortal};

    .option {
      padding-top: 10px;
      z-index: ${zIndex.ConfirmModalPortal};
      color: #fff;
      ${typo.body02};
    }

    .right-bottom-close-text-button {
      padding-top: 10px;
      z-index: ${zIndex.ConfirmModalPortal};
      color: #fff;
      ${typo.body02};
    }

    &.cta-container__right {
      justify-content: flex-end;
    }
  `,
} as const

export default S
